import * as React from 'react'
import styled from 'styled-components'
import {observer} from 'mobx-react'
import {Button} from '../elements/Button'

export interface IModalProps {
  isOpen: boolean
  onOk: () => void
  className?: string
  unAnsweredQuestions?: string[]
}

@observer
class ConfirmationModalClass extends React.Component<IModalProps> {
  static defaultProps: Pick<IModalProps, 'isOpen'> = {
    isOpen: false
  }

  render() {
    return (
      <div className={this.props.className}>
        <ModalContent onClick={e => e.stopPropagation()}>
          <ModalHeader>
            <ModalTitle>Et ole vastannut kaikkiin kysymyksiin!</ModalTitle>
          </ModalHeader>
          {this.props.unAnsweredQuestions && (
            <NoAnswers>
              <strong>Kysymykset ilman vastausta</strong>
              <ul style={{paddingLeft: 0}}>
                {this.props.unAnsweredQuestions.map(q => (
                  <li key={q}>- {q}</li>
                ))}
              </ul>
            </NoAnswers>
          )}
          <p>Vaalikoneprofiilisi näkyy yleisöllä vasta kun olet vastannut kaikkiin kysymyksiin</p>
          <p>Voit palata seuraavasta näkymästä muokkaamaan vastauksiasi</p>
          <Buttons>
            <Button onClick={this.props.onOk} height="40px" fontSize="18px">
              Jatka
            </Button>
          </Buttons>
        </ModalContent>
      </div>
    )
  }
}

const ModalTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 0;
`

const Buttons = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: space-around;

  ${Button} {
    margin: 0 5px;
  }
`
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`
const NoAnswers = styled.div`
  padding: 10px;
  background: #eee;
  border-radius: 4px;
  margin: 10px 0;
`
const ModalContent = styled.div`
  padding: 1rem 2rem;
  background: white;
  width: 90%;
  max-width: 420px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: 10% auto auto auto;
  border-radius: 4px;
`

export const ConfirmationModal = styled(ConfirmationModalClass)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1000;
  overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.55);
`
